<template>
  <q-btn
    ref="button"
    :label="isEmpty(column.filter) ? column.label : `${column.label}: ${getFilterValues}`"
    :class="[{
      'filter-button': true,
      'selected': !isEmpty(column.filter),
      'highlighted': highlightedButton === column.name
    }]"
    icon-right="keyboard_arrow_down"
    flat
    no-caps
  >
    <q-popover
      v-if="column.searchRequest"
      @show="onPopoverShow()"
      @hide="releaseButton()"
      :offset="popperOffset"
      ref="popover"
      anchor="bottom left"
      self="top left">
      <q-input
        v-model="inputText"
        @input="(query) => searchValues(query, column)"
        :loading="loading"
        :before="[{icon: 'search'}]"
        autofocus
        hide-underline
        clearable
        placeholder="Поиск..."
        type="search"
        :ref="`input-${column.name}`"
      />
      <div v-if="filteredValues.length"
           style="max-height: 300px; overflow: auto; border-top: 1px solid #bbb;"
      >
        <div
          v-for="item in filteredValues"
          :key="item.value"
        >
          <q-checkbox
            :val="item.value"
            :label="item.label"
            v-model="column.filter"
            @input="deferredSearch(column); setColumnValues(column, item)"
          />
        </div>
      </div>
      <div
        v-if="inputText.length > 2 && !filteredValues.length"
        style="padding: 15px; color: #666; font-size: 14px; border-top: 1px solid #bbb;"
      >
        Нету совпадений
      </div>
      <div
        v-if="inputText.length <= 2 && !filteredValues.length && !column.values"
        style="padding: 15px; color: #666; font-size: 14px; border-top: 1px solid #bbb;"
      >
        Введите больше 3 символов
      </div>
    </q-popover>
    <q-popover
      v-if="!column.searchRequest && column.values.length > 5"
      @show="onPopoverShow()"
      @hide="releaseButton()"
      :offset="popperOffset"
      ref="popover"
      anchor="bottom left"
      self="top left">
      <q-input
        v-model="inputText"
        @input="val => filterValues(val, column)"
        :loading="loading"
        :before="[{icon: 'search'}]"
        hide-underline
        clearable
        placeholder="Поиск..."
        type="search"
        :ref="`input-${column.name}`"/>
      <div
        v-if="filteredValues.length"
        style="max-height: 300px; overflow: auto; border-top: 1px solid #bbb;"
      >
        <div v-for="item in filteredValues" :key="item.value">
          <q-checkbox
            :val="item.value"
            :label="item.label"
            v-model="column.filter"
            @input="deferredSearch(column)"
          />
        </div>
      </div>
      <div
        v-if="!filteredValues.length"
        style="padding: 15px; color: #666; font-size: 14px; border-top: 1px solid #bbb;"
      >
        Нету совпадений
      </div>
    </q-popover>
    <q-popover v-if="!column.searchRequest && column.values.length <= 5"
               @show="highlightButton(column.name)"
               @hide="releaseButton()"
               :offset="popperOffset"
               ref="popover"
               anchor="bottom left"
               self="top left">
      <div v-for="item in column.values" :key="item.value">
        <q-checkbox :val="item.value" :label="item.label" v-model="column.filter"
                    @input="valueSearch(column)"/>
      </div>
    </q-popover>
  </q-btn>

</template>

<script>
  import {
    QBtn,
    QPopover,
    QInput,
    QDatetimePicker,
    QCheckbox,
    QSearch,
    QIcon,
    date
  } from 'quasar';

  import TableFilterBase from './TableFilterBase';

  export default {
    name: 'TableFilterValue',
    components: {
      QBtn,
      QPopover,
      QInput,
      QDatetimePicker,
      QCheckbox,
      QSearch,
      QIcon
    },
    extends: TableFilterBase,
    props: {
      column: {
        type: Object,
        default: {}
      },
      columns: {
        type: Array,
        default: []
      }
    },
    methods: {
      onPopoverShow () {
        this.inputText = '';
        this.updateFilteredValues(this.column);
        this.focusInput(this.column.name);
        this.highlightButton(this.column.name);
      },
      valueSearch (column) {
        if (column.onlyOneFilter) {
          column.filter = column.filter.length > 0 ? [column.filter.pop()] : [];
        }
        
        return this.deferredSearch(column);
      }
    },
    beforeMount () {
      if (typeof this.column.values === 'function') {
        if (this.column.filter.length) {
          const valuesRequest = this.column.values(this.column);

          valuesRequest
            .then(response => {
              this.column.values = response;
            });
        } else {
          this.column.values = [];
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "./style";
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/TableFilter/TableFilterValue.vue